import { render } from "./WomensClothing.vue?vue&type=template&id=2af97d18"
import script from "./WomensClothing.vue?vue&type=script&lang=js"
export * from "./WomensClothing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__